module.exports = __webpack_public_path__ + "static/media/Search-sticky-background-v2.a160f33f.png";